<template>
    <v-list
        :id="gtmTrackerId"
        dense
        :class="{
            'pt-0': isAlternativeMode,
            'pt-4': !isAlternativeMode,
        }"
    >
        <v-list-item
            v-for="(filterItem, filterName, index) in filterData"
            :key="`${filterName}-${index}`"
            class="habiteo-body-2 checkbox-item"
            :class="{
                'pb-0': isAlternativeMode,
                'pb-4': !isAlternativeMode,
            }"
        >
            <TextItem
                :filterType="filterType"
                :filterItem="filterItem"
                :filterName="filterName.toString()"
                @filter-method="filterBy"
            />
        </v-list-item>
    </v-list>
</template>

<script>
    import TextItem from "@/components/filters/TextItem";
    import { mapGetters } from 'vuex';

    export default {
        name: "TextItems",
        components: {
            TextItem
        },
        computed: {
            ...mapGetters([
                'isAlternativeMode'
            ]),
            gtmTrackerId() {
                return `gtm-filter-${this.$props.filterType}`;
            }
        },
        props: {
            filterData: {
                type: [Object, Array],
                required: true,
            },
            filterType: {
                type: String,
                required: true,
            }
        },
        methods: {
            filterBy(filter) {
                this.$emit('filter-method', filter);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/filters/TextItems.vue